"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
function getFileExtension(filePath) {
    const pathParts = /^.+\.([^.]+)$/.exec(filePath);
    if (pathParts && pathParts.length > 1) {
        return pathParts[1];
    }
    return null;
}
exports.getFileExtension = getFileExtension;
function getPathWithoutExtension(filePath, extension) {
    let pathWithoutExtension = filePath;
    if (extension) {
        pathWithoutExtension = filePath.substr(0, filePath.length - (extension.length + 1));
    }
    return pathWithoutExtension;
}
exports.getPathWithoutExtension = getPathWithoutExtension;
function handleExtensionErr(extension) {
    if (extension) {
        throw Error(`cannot require() module with extension '${extension}'`);
    }
}
function resolveFile(filePath) {
    const extension = getFileExtension(filePath);
    const pathWithoutExtension = getPathWithoutExtension(filePath, extension);
    switch (extension) {
        case 'js': {
            return require.resolve(pathWithoutExtension + '.js');
        }
        case 'json': {
            return require.resolve(pathWithoutExtension + '.json');
        }
        default: {
            try {
                return require.resolve(filePath + '.js');
            }
            catch (err) {
                try {
                    return require.resolve(filePath + '.json');
                }
                catch (err) {
                    handleExtensionErr(extension);
                    throw err;
                }
            }
        }
    }
}
exports.resolveFile = resolveFile;
function requireFile(filePath) {
    const extension = getFileExtension(filePath);
    const pathWithoutExtension = getPathWithoutExtension(filePath, extension);
    switch (extension) {
        case 'js': {
            if (resolveFile(pathWithoutExtension + '.js')) {
                return Promise.resolve().then(() => __importStar(require(pathWithoutExtension + '.js')));
            }
            return null;
        }
        case 'json': {
            if (resolveFile(pathWithoutExtension + '.json')) {
                return Promise.resolve().then(() => __importStar(require(pathWithoutExtension + '.json')));
            }
            return null;
        }
        default: {
            try {
                if (resolveFile(filePath + `.js`)) {
                    return Promise.resolve().then(() => __importStar(require(filePath + '.js')));
                }
            }
            catch (err) {
                handleExtensionErr(extension);
            }
            if (resolveFile(filePath + `.json`)) {
                return Promise.resolve().then(() => __importStar(require(filePath + '.json')));
            }
            handleExtensionErr(extension);
        }
    }
}
exports.requireFile = requireFile;
//# sourceMappingURL=file.js.map